import {LazyRoute, BoringRoute, Parse} from 'bigdatr-style';
import {safeLazyImport} from 'bigdatr-style';
import {UserAdminUserListArgs} from '~/user/UserAdminUserList';

const UserAdminTeamList = safeLazyImport(() => import('~/user/UserAdminTeamList'));
const UserAdminTeamUsers = safeLazyImport(() => import('~/user/UserAdminTeamUsers'));
const UserAdminTeamAccess = safeLazyImport(() => import('~/user/UserAdminTeamAccess'));
const UserAdminTeamApi = safeLazyImport(() => import('~/user/UserAdminTeamApi'));
const UserAdminTeamDangerZone = safeLazyImport(() => import('~/user/UserAdminTeamDangerZone'));
const UserAdminUserList = safeLazyImport(() => import('~/user/UserAdminUserList'));
const UserAdminUserItem = safeLazyImport(() => import('~/user/UserAdminUserItem'));
const ContentMover = safeLazyImport(() => import('~/feature/content-mover/ContentMover'));

export default {
    userAdminTeamList: LazyRoute<{status?: string; q?: string}>({
        path: '/user-admin/team',
        parse: {
            status: Parse.query.string((x) => x || 'ACTIVE'),
            q: Parse.query.string((x) => x || '')
        },
        component: UserAdminTeamList
    }),
    userAdminTeamUsers: LazyRoute<{id: string; q?: string}>({
        path: '/user-admin/team/:id/users',
        parse: {
            id: Parse.param.string((x) => x || ''),
            q: Parse.query.string((x) => x || '')
        },
        component: UserAdminTeamUsers
    }),
    userAdminTeamDangerZone: LazyRoute<{id: string}>({
        path: '/user-admin/team/:id/danger-zone',
        parse: {
            id: Parse.param.string((x) => x || '')
        },
        component: UserAdminTeamDangerZone
    }),
    userAdminTeamAccess: LazyRoute<{id: string}>({
        path: '/user-admin/team/:id/access',
        parse: {
            id: Parse.param.string((x) => x || '')
        },
        component: UserAdminTeamAccess
    }),
    userAdminTeamApi: LazyRoute<{id: string}>({
        path: '/user-admin/team/:id/api',
        parse: {
            id: Parse.param.string((x) => x || '')
        },
        component: UserAdminTeamApi
    }),
    userAdminUserList: LazyRoute<UserAdminUserListArgs>({
        path: '/user-admin/user',
        component: UserAdminUserList,
        parse: {
            pagination: Parse.query.JSON((x) => x as UserAdminUserListArgs['pagination']),
            orderBy: Parse.query.JSON((x) => x as UserAdminUserListArgs['orderBy']),
            filter: Parse.query.JSON((x) => x as UserAdminUserListArgs['filter'])
        }
    }),
    userAdminUserItem: LazyRoute<{id: string}>({
        path: '/user-admin/user/:id',
        parse: {
            id: Parse.param.string((x) => x || '')
        },
        component: UserAdminUserItem
    }),
    contentMover: BoringRoute({
        path: '/user-admin/content-mover',
        component: ContentMover
    })
};
